import { Container, Row } from "reactstrap";
import NumberingWizard from "./NumberingWizard";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { FormLayoutTitle, FormWidgetsTitle } from "../../../../../Constants/Constants";
import StudentValidationForm from './StudentValidationForm'
import VerticalValidationWizard from './VerticalValidationWizard'
import ShippingForm from './ShippingForm'

const FormWizard1Container = () => {
  return (
    <>
      <Breadcrumbs mainTitle={FormWidgetsTitle} parent={FormLayoutTitle} />
      <Container fluid>
        <Row>
          <NumberingWizard />
          <StudentValidationForm/>
          <VerticalValidationWizard/>
          <ShippingForm/>
        </Row>
      </Container>
    </>
  );
};
export default FormWizard1Container;
